import React from "react";

const Events = [
	{title: 'день народного единства',
		month: 10,
		year: [new Date().getFullYear(), (new Date().getFullYear()+1), (new Date().getFullYear()+2)],
		day: 4,
	notes: '',
	cat: 'holidays',
	id: 387938725,
},
{title: 'Новый год',
		month: 11,
		year: [new Date().getFullYear(), (new Date().getFullYear()+1), (new Date().getFullYear()+2)],
		day: 31,
	notes: 'купить подарки',
	cat: 'holidays',
	id: 34745727,
},
{title: 'Рождество',
		month: 0,
		year: [new Date().getFullYear(), (new Date().getFullYear()+1), (new Date().getFullYear()+2)],
		day: 7,
	notes: '',
	cat: 'holidays',
	id: 34795724545,
},
{title: 'Старый Новый Год',
		month: 0,
		year: [new Date().getFullYear(), (new Date().getFullYear()+1), (new Date().getFullYear()+2)],
		day: 14,
	notes: '',
	cat: 'holidays',
	id: 34795754525,
},
{title: 'день студента',
		month: 0,
		year: [new Date().getFullYear(), (new Date().getFullYear()+1), (new Date().getFullYear()+2)],
		day: 25,
	notes: '',
	cat: 'holidays',
	id: 34345795725,
},
{title: 'День святого Валентина',
		month: 1,
		year: [new Date().getFullYear(), (new Date().getFullYear()+1), (new Date().getFullYear()+2)],
		day: 14,
	notes: '',
	cat: 'holidays',
	id: 34795983725,
},
{title: 'Международный женский день',
		month: 2,
		year: [new Date().getFullYear(), (new Date().getFullYear()+1), (new Date().getFullYear()+2)],
		day: 8,
	notes: '',
	cat: 'holidays',
	id: 34795232725,
},
{title: 'День смеха',
		month: 3,
		year: [new Date().getFullYear(), (new Date().getFullYear()+1), (new Date().getFullYear()+2)],
		day: 1,
	notes: '',
	cat: '',
	id: 3479570982425,
},
{title: 'день защитника отечества',
	
		month: 1,
		year: [new Date().getFullYear(), (new Date().getFullYear()+1), (new Date().getFullYear()+2)],
		day: 23,
	
	notes: '',
	cat: '',
	id: 34795709782425,
}
]



export default Events;